__turbopack_context__.v({
  "manage-groups-container": "ManageGroups-module__obctea__manage-groups-container",
});
